import React from 'react';
import { Typography } from '@/UI/Components/Typography/Typography';
import { ChevronRight, MessageCircle } from 'react-feather';
import DownloadAppButton from '@/UI/Components/DownloadAppButton/DownloadAppButton';

const IntroSection: React.FC = () => {
	return (
		<div className="overflow-hidden bg-gradient-to-br from-[#4660ff] via-[#5a75ff] to-[#6e8aff] min-h-[calc(100vh-70px)] md:min-h-[calc(100vh-90px)]">
			<div className="flex flex-col gap-6 sm:flex-row sm:justify-center items-center min-h-full py-8 md:py-12 px-4">
				<div className="flex flex-col md:flex-row w-full md:w-4/5 gap-8 md:gap-12 justify-center items-center">
					<div className="flex flex-col gap-8 w-full md:w-1/2 animate-fadeIn">
						<div className="mb-4 md:mb-8">
							<div className="block md:hidden leading-tight">
								<Typography size={44} weight="bold" color="white">
									Finanzas Incluyentes para Todos
								</Typography>
							</div>
							<div className="hidden md:block leading-tight">
								<Typography size={56} weight="bold" color="white">
									Finanzas Incluyentes para Todos
								</Typography>
							</div>
						</div>
						<div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-xl border border-white/20 mb-4 2xl:mb-12 transform transition-all duration-300 hover:shadow-2xl">
							<p className="text-gray-800 text-lg md:text-xl leading-relaxed">
								En Fincluyente, creemos en un futuro financiero accesible para todos. Somos una
								plataforma inclusiva que elimina las barreras tradicionales. Con nuestro enfoque en
								la inclusión, democratizamos el acceso al crédito y otros servicios financieros,
								asegurando que cada persona en México pueda tomar el control de su futuro financiero
								con confianza y seguridad.
							</p>
						</div>
						<div className="flex flex-col sm:flex-row gap-4">
							<DownloadAppButton buttonColor="#4660ff" />
							<a
								className="py-3 px-6 rounded-full flex flex-row gap-2 items-center justify-center bg-white/10 backdrop-blur-sm border border-white/30 text-white hover:bg-white/20 transition-all duration-300 hover:scale-105 shadow-lg"
								target="_blank"
								href={`https://wa.me/+525625466550?text=${encodeURIComponent('Hola Finclu!')}`}
							>
								<MessageCircle className="w-5 h-5" />
								<Typography size={14} weight="semibold" color="white">
									Habla con Finclu
								</Typography>
								<ChevronRight className="w-4 h-4" />
							</a>
						</div>
					</div>
					<div className="flex items-center justify-center w-full md:w-1/2">
						<div className="relative w-full max-w-md">
							<div className="absolute inset-0 bg-white/20 rounded-3xl blur-3xl transform scale-110"></div>
							<img
								src="/IntroSectionImage.png"
								alt="Fincluyente App"
								className="relative w-full h-auto object-contain transform transition-transform duration-500 hover:scale-105"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default IntroSection;
